<template>
  <div>
    <q-dialog ref="modal" :maximized="true">
      <q-card>
        <q-toolbar class="bg-primary">
          <q-toolbar-title><span class="text-body1 text-white">Buscar estoque lojas</span></q-toolbar-title>
          <q-btn flat round dense color="white" icon="close" v-close-popup />
        </q-toolbar>

        <q-lins-filter-box :expanded="expand" @update="expand = !expand" :aplicarBusca="buscarProduto"
          :limpar="limpaDados">
          <template v-slot:filtros>
            <div class="q-gutter-x-sm justify-center" :class="$q.screen.xs ? 'q-gutter-y-sm' : 'row'">
              <q-select v-model="filtros.cor" label="Cor" :options="optionsCores"
                :class="$q.screen.xs ? '' : 'col q-pr-sm'" />
              <q-select v-model="filtros.tamanho" label="Tamanho" :options="optionsTamanhos"
                :class="$q.screen.xs ? '' : 'col q-pl-sm'" clearable />
              <q-select v-model="filtros.loja" label="Loja" :options="optionsLojas"
                :class="$q.screen.xs ? '' : 'col q-pr-sm'" clearable />
            </div>
          </template>
        </q-lins-filter-box>
        <q-card-section class="no-margin q-pa-xs">
        </q-card-section>

        <q-card-section class="no-margin q-pa-xs">
          <q-card class="shadow-2 q-pa-xs" v-if="listaEstoques.length != 0">
            <q-lins-table
              id="tabEstoquesCores"
              ref="tabEstoquesCores"
              :data-table="listaEstoques"
              :auto-load="false"
              :columns="columns"
              :expand="true"
              :pagination="false"
            >
              <template v-slot:expand="props">
                <q-lins-table
                  class="shadow-1"
                  :id="`tabConsultaExpandTam${props.row.id}`"
                  :ref="`tabConsultaExpandTam${props.row.id}`"
                  :data-table="props.row.tamanhos"
                  :columns="columnsExpandTam"
                  :pagination="false"
                  :auto-load="false"
                  :expand="true"
                >
                  <template v-slot:expand="props">
                    <q-lins-table
                      style="margin-left: 3rem;"
                      :id="`tabConsultaExpandFil${props.row.id}`"
                      :auto-load="false"
                      :ref="`tabConsultaExpandFil${props.row.id}`"
                      :data-table="props.row.lojas"
                      :columns="columnsExpandFil"
                      :pagination="false"
                    />
                  </template>
                </q-lins-table>
              </template>
            </q-lins-table>
          </q-card>
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>
<script>
import { ref } from 'vue'
import QLinsTable from '@/shared/QLinsDrfTable.vue'
import QLinsFilterBox from '@/shared/QlinsFilterBox.vue';
import MixinMessages from '@/mixins/mixinMessagens';
import EstoqueServices from '@/services/estoque'
import ServiceLojas from '@/services/lojas'
import { useStore } from 'vuex';

export default {
  components: { QLinsTable, QLinsFilterBox },
  mixins: [MixinMessages],
  // inject: ['estoque'], not yet stable in this quasar version
  props: {
    dados: {
      type: Array,
      required: true
    }
  },
  mounted() {
    this.formataOptions()
    this.buscaLojas()
  },

  setup() {
    const store = useStore()
    const expand = ref(true)
    const filtros = ref({
      cor: '',
      tamanho: '',
      loja: ''
    })
    const columns = ref([
      {
        name: "cor_predominante",
        field: 'cor_predominante',
        label: "Cor",
        align: "left",
        width: "30ch"
      },
      {
        name: "total",
        field: 'total',
        label: "Total",
        align: "center",
      },
      {
        name: "emLoja",
        field: 'emLoja',
        label: "Em Loja",
        align: "center",
      },
      {
        name: "emCondicional",
        field: "emCondicional",
        label: "Em Condicional",
        align: "center",
      },
      {
        name: "reservado",
        field: "total_reservado",
        label: "Reservado",
        align: "center",
      },
    ])
    const columnsExpandTam = ref([
      {
        name: "cod_tamanho",
        field: 'cod_tamanho',
        label: "Tamanho",
        sort: "cod_tamanho",
        align: "left",
        width: "20ch"
      },
      {
        name: "Total",
        field: 'total',
        label: "Total",
        align: "center",
      },
      {
        name: "emLoja",
        field: 'emLoja',
        label: "Em loja",
        align: "center",
      },
      {
        name: "emCondicional",
        field: "emCondicional",
        label: "Em condicional",
        align: "center",
      },
      {
        name: "estReservado",
        field: "total_reservado",
        label: "Reservado",
        align: "center",
      },
    ]
    )
    const columnsExpandFil = ref([
      {
        name: "filial",
        field: 'cod_filial',
        label: "Filial",
        align: "left",
        width: "20ch",
        format: val => `Filial ${val}`
      },
      {
        name: "total",
        field: 'total',
        label: "Total",
        align: "left",
        format(value, row) {
          return parseInt(row.total_loja)
        }
      },
      {
        name: "loja",
        field: 'qtd_loja',
        label: "Em loja",
        align: "center",
      },
      {
        name: "estCondicional",
        field: 'est_condicional',
        label: "Em condicional",
        align: "center",
      },
      {
        name: "estReservado",
        field: "tot_reserva",
        label: "Reservado",
        align: "center",
      },
    ]
    )
    let optionsCores = ref([])
    let optionsTamanhos = ref([])
    const listaEstoques = ref([])
    const optionsLojas = ref([])
    return {
      columns,
      columnsExpandTam,
      columnsExpandFil,
      icon: ref(false),
      filtros,
      optionsCores,
      optionsTamanhos,
      listaEstoques,
      optionsLojas,
      store,
      expand
    }
  },
  methods: {
    formataOptions() {
      // this.estoque.value.map(estoque => {
      //   estoque.loja.produtos.map(produto => {
      //     this.optionsCores.push({ label: produto.cor_predominante, value: produto.cod_produto })
      //     produto.tamanhos.map(tamanho => {
      //         this.pushUnique({ label: tamanho.cod_tamanho, value: tamanho.cod_tamanho }, this.optionsTamanhos)
      //     })
      //   })
      // })
      this.dados.map(estoque => {
        estoque.loja.produtos.map(produto => {
          const cor_predominante = produto.cor_predominante
          const cor_02 = produto.cor_02 ? `/ ${produto.cor_02}` : ''
          const cor_03 = produto.cor_03 ?  `/ ${produto.cor_03}` : ''
          this.optionsCores.push({ label: `${cor_predominante} ${cor_02} ${cor_03}`, value: produto.cod_produto })
          produto.tamanhos.map(tamanho => {
            this.pushUnique({ label: tamanho.cod_tamanho, value: tamanho.cod_tamanho }, this.optionsTamanhos)
          })
        })
      })
    },
    buscaLojas() {
      ServiceLojas.get({ cod_rede: this.store.getters.getCodigoRede })
        .then((res) => {
          const lojas = res.lojas
          this.optionsLojas = lojas.map(loja => {
            return { label: loja.nome_filial, value: loja.cod_filial }
          })
        })
    },
    show() {
      this.$refs.modal.show()
    },
    hide() {
      this.$refs.modal.hide()
    },
    buscarProduto() {
      this.listaEstoques = []
      this.$_showLoading({ message: "Buscando estoque do produto" })
      let params = {}
      if (!this.filtros.cor.value) {
        this.errorMessage({
          title: "Erro",
          message: "Por favor informe a cor do produto"
        })
        this.$_hideLoading()
      } else {
        this.filtros.cor.value ? params.cod_produto = this.filtros.cor.value : ''
        this.filtros.tamanho.value ? params.cod_tamanho = this.filtros.tamanho.value : ''
        this.filtros.loja.value ? params.cod_filial = this.filtros.loja.value : ''
        EstoqueServices.buscarEstoque(params)
          .then(res => {
            this.$_hideLoading()
            this.formataDadosTabela(res)
            this.expand = false
          })
          .catch(error => {
            this.$_hideLoading()
            console.log(error)
          })
      }
    },
    formataDadosTabela(dados) {
      this.$_showLoading({ message: "Buscando estoques do produto" })
      let produto = {
        cor_predominante: this.filtros.cor.label,
        tamanhos: [],
        total: 0,
        emLoja: 0,
        emCondicional: 0,
        total_reservado: 0,
      }
      let formatadoPromise = dados.tamanhos.map((tamanho) => {
        tamanho.emCondicional = 0
        tamanho.emLoja = 0
        tamanho.total = 0
        tamanho.total_reservado = 0
        const filiais = tamanho.lojas.filter((filial) => (parseInt(filial.total_loja) > 0) || (parseInt(filial.tot_reserva) > 0))
          .map((filial) => {
            tamanho.emCondicional = parseInt(filial.est_condicional) + parseInt(tamanho.emCondicional)
            tamanho.emLoja = parseInt(filial.qtd_loja) + parseInt(tamanho.emLoja)
            tamanho.total_reservado = parseInt(filial.tot_reserva) + parseInt(tamanho.total_reservado)
            tamanho.total = parseInt(filial.total_loja) + parseInt(tamanho.total)
            return filial
          })
        tamanho.lojas = filiais
        produto.total = parseInt(produto.total) + parseInt(tamanho.total)
        produto.emCondicional = parseInt(produto.emCondicional) + parseInt(tamanho.emCondicional)
        produto.emLoja = parseInt(produto.emLoja) + parseInt(tamanho.emLoja)
        produto.total_reservado = parseInt(produto.total_reservado) + parseInt(tamanho.total_reservado)
        return tamanho
      })
      Promise.all(formatadoPromise).then(formatados => {
        produto.tamanhos = formatados
        this.listaEstoques.push(produto)
        this.$_hideLoading()
      })
    },
    pushUnique(item, array) {
      if (!array.some(el => el.value == item.value)) {
        array.push(item)
      }
    },
    limpaDados() {
      this.filtros.loja = ''
      this.filtros.tamanho = ''
      this.filtros.cor = ''
    },
    $_showLoading(options) {
      this.$q.loading.show(options)
    },

    $_hideLoading() {
      this.$q.loading.hide()
    }
  }
}
</script>